/**
 * AgentForge — Hugging Face Xet bucket for app durable data (Binder pattern).
 *
 *   hf sync ./data hf://buckets/copperscout1/agentforge-user
 *
 * Local mirror: agentforge/data/
 * Sync: npm run hf:sync | hf:pull
 *
 * One shared app bucket only — never create agentforge-u-* per-user buckets.
 * Multi-tenant isolation (if needed) = path prefixes under ./data/user/{key}/.
 */

export const AGENTFORGE_HF_BUCKET = "copperscout1/agentforge-user";
export const AGENTFORGE_HF_BUCKET_URI = `hf://buckets/${AGENTFORGE_HF_BUCKET}`;

/** Local shelves under ./data (mirrored to the bucket). */
export const AGENTFORGE_DATA_SHELVES = [
  "runs",
  "screenshots",
  "presets",
  "bindings",
  "meta",
  "user",
] as const;

export type AgentforgeDataShelf = (typeof AGENTFORGE_DATA_SHELVES)[number];

export function agentforgeBucketSyncPushCmd(localDir = "./data"): string {
  return `hf sync ${localDir} ${AGENTFORGE_HF_BUCKET_URI}`;
}

export function agentforgeBucketSyncPullCmd(localDir = "./data"): string {
  return `hf sync ${AGENTFORGE_HF_BUCKET_URI} ${localDir}`;
}
